<template>
  <div class="swiper-card card-thread">
    <h1>{{ slide.thread.name }}</h1>

    <div class="clips">
      <thread-clip isLegacy="true" :element="slide.content" :paper="slide.thread" :key="`inner-clip-${slide.content.slug}`"/>
    </div>
  </div>
</template>

<script>
  import ThreadClip from 'app/components/ThreadClip';

  export default {
    props: {
      slide: {
        type: Object,
      },
    },

    components: {
      ThreadClip,
    },

    mounted () {
      // Update swiper and enable next
      this.$emit('swiperUpdate');
      this.$emit('enableNextAction');
    },
  }
</script>

<style lang="scss" scoped>
  @import 'src/assets/scss/v5_stacks.scss';

  .card-thread {
    padding: 2rem 0 0 0;

    h1 {
      text-wrap: balance;
    }

    .clips {
      margin-top: 1rem;
      padding-left: 2rem;
      padding-top: 2rem;
      border-top: 1px solid rgba($neutral-400, 0.25);

      ::v-deep {
        .thread-clip-wrapper {
          &:not(:last-child) {
            margin-bottom: 2rem;
            padding-bottom: 2rem;
            border-bottom: 1px solid rgba($neutral-400, 0.25);
          }
        }

        h3 {
          font-size: 1.2rem;
          line-height: 140%;
        }
      }
    }
  }
</style>